import { effectiveSeo, seoChecks } from '../../core/rules/seo'
import { mediaProblem } from '../../core/rules/media'
import { SITE_NAME } from '../../data/seo'
import { articleSeoAuto, productSeoAuto, routineSeoAuto, treatmentSeoAuto } from '../../utils/seoAuto'
import type { Check } from '../editing'
import type { Product, Routine, Treatment } from '../../core/types/catalog'
import type { Article } from '../../core/types/content'

/**
 * De vindbaarheidscontroles per soort, voor "Wat mist er nog?". Dubbele titels worden alleen
 * binnen hetzelfde soort gezocht (twee producten met dezelfde titel), met de automatische terugval.
 */

const titlesOf = <T,>(items: T[], self: T, title: (x: T) => string) => items.filter((x) => x !== self).map(title)

export function productSeoChecks(p: Product, all: Product[]): Check[] {
  const title = (x: Product) => effectiveSeo(x.seo, productSeoAuto(x)).title
  const others = titlesOf(
    all.filter((x) => x.kind !== 'giftcard' && x.id !== p.id),
    p,
    title,
  )
  // Een cadeaubon heeft geen eigen pagina, dus ook geen Google-regel.
  if (p.kind === 'giftcard') return []
  return seoChecks({ seo: p.seo, auto: productSeoAuto(p), otherTitles: others, siteName: SITE_NAME, hasImageAlt: p.image ? Boolean(p.imageAlt?.trim()) : undefined })
}

export function articleSeoChecks(a: Article, all: Article[]): Check[] {
  const others = titlesOf(all.filter((x) => x.slug !== a.slug), a, (x) => effectiveSeo(x.seo, articleSeoAuto(x)).title)
  return seoChecks({ seo: a.seo, auto: articleSeoAuto(a), otherTitles: others, siteName: SITE_NAME })
}

export function routineSeoChecks(r: Routine, all: Routine[]): Check[] {
  const others = titlesOf(all.filter((x) => x.id !== r.id), r, (x) => effectiveSeo(x.seo, routineSeoAuto(x)).title)
  return seoChecks({ seo: r.seo, auto: routineSeoAuto(r), otherTitles: others, siteName: SITE_NAME })
}

export function treatmentSeoChecks(t: Treatment, all: Treatment[]): Check[] {
  const others = titlesOf(all.filter((x) => x.slug !== t.slug), t, (x) => effectiveSeo(x.seo, treatmentSeoAuto(x)).title)
  const checks = seoChecks({ seo: t.seo, auto: treatmentSeoAuto(t), otherTitles: others, siteName: SITE_NAME })
  const problem = t.media ? mediaProblem(t.media) : null
  return problem ? [{ level: 'error', text: `Beeld: ${problem}` }, ...checks] : checks
}
